import React, { useEffect, Fragment, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import styled from 'styled-components'
import ScreenWrapper from '../../shared/ScreenWrapper'
import Text from '../../shared/Text'
import Switch from 'react-bootstrap/Switch';
import { dissectName } from '../../../utility/helpers'
import styles from '../../../utility/styles'
import {
	FoundersIcon,
	FoundersIconBlack,
	ProIconGold,
	ProIconBlack,
	ProIconBlue,
	FreeIcon,
} from '../../../utility/icons'
import GiftRedemptionPanel from './GiftRedemptionPanel'
import { get, post } from '../../../utility/api'
import Button from '../../shared/Button'
import AddConnectionsMenu from './AddConnectionsMenu'
import ProUpgradeMenu from './ProUpgradeMenu';
import MessageToast from '../../shared/MessageToast';
import ManageSubscriptionPanel from './ManageSubsciptionPanel';
import Skeleton from '../../shared/Skeleton';

const StyeldContainer = styled(Container)`
	margin-top: 72px;
	margin-bottom: 72px;
	@media only screen and (max-width: 768px) {
		padding: 0 24px;
	}
`

const UserColumn = styled.div`
	display: flex;
	flex-direction: column;
	margin: 48px 0;
`

const UserRow = styled.div`
	display: flex;
	align-items: center;
`

const StyledCol = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`

const StyledRow = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	@media only screen and (max-width: ${({ column }) => column || '1px'}) {
		flex-direction: column;
		align-items: flex-start;
		&.icon {
			margin-bottom: 16px;
		}
	}
	@media only screen and (max-width: ${({ columnReverse }) => columnReverse || '1px'}) {
		flex-direction: column-reverse;
		justify-content: center;
	}
`

const OfferBadgeWrapper = styled.div`
	padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid ${styles.colors.founders};
    margin-left: 16px;
    align-self: middle;
`

const OfferNoticeWrapper = styled.div`
	display: flex;
	height: 100%;
	width: 24px;
	position: absolute;
	justify-content: center;
	align-items: center;
	background-color: ${styles.colors.founders};
`

const OfferText = styled(Text.Caption)`
	transform: rotate(90deg);
	min-width: 90px;
`

const FakeButton = styled.div`
	display: flex;
	align-items: center;
	border-radius: 1px;
	padding-top: 4px;
	padding-bottom: 4px;
	padding-left: ${({ loading }) => (loading ? '0' : '12px')};
	color: ${({ active }) =>
		active ? styles.colors.background : styles.colors.whiteGray};
	background-color: ${({ active, loading }) =>
		loading
			? 'transparent'
			: active
				? styles.colors.success
				: 'transparent'};
`

const AvatarBacker = styled.div`
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: content-box;
	border: 2px solid ${styles.colors.blue};
	height: 64px;
	width: 64px;
	border-radius: 32px;
	margin-right: 24px;
	background-color: ${styles.colors.darkGray};
	font-size: 24px;
	font-weight: bold;
`

const Avatar = styled.img`
	width: 64px;
	height: 64px;
	background-color: ${styles.colors.darkGray};
	border-radius: 32px;
	margin-right: 24px;
`

const ConnectionMessageWrapper = styled.div`
	display: flex;
	padding: 24px 40px;
	align-items: center;
	gap: 32px;
	align-self: stretch;
	border-radius: 8px 8px 0px 0px;
	border: 1px solid ${styles.colors.darkGray};
`

const TextSpan = styled.span`
	font-weight: bold;
	color: ${styles.colors.alert};
`

const VehicleWrapper = styled.div`
	display: flex;
	padding: 12px 16px;
	align-items: center;
	justify-content: space-between;
	align-self: stretch;
	background-color: ${styles.colors.darkGray};
	margin-bottom: 4px;
	border-bottom-right-radius: ${({ isLast }) => (isLast ? '8px' : '0')};
	border-bottom-left-radius: ${({ isLast }) => (isLast ? '8px' : '0')};
`;

const VehicleImage = styled.div`
	background: center / cover url(${({ src }) => src}) no-repeat;
	width: 67.068px;
	height: 48px;
`;

const StyledSwitch = styled(Switch)`
    display: flex;
    & .form-check-input {
        cursor: pointer;
        height: 32px;
        width: 48px;
        background-color: ${styles.colors.lightGray};
        border-color: ${styles.colors.lightGray};
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e");
        &:checked {
            background-color: ${styles.colors.success};
            border-color: ${styles.colors.success};
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e");
        }
		@media only screen and (max-width: 375px) {
			height: 24px;
			width: 36px;
		}
    }
`

const ConnectedText = styled(Text.Caption)`
	@media only screen and (max-width: 480px) {
		display: none;
	}
`

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 32px;
`

const ProUpgradeButton = styled(Button)`
	background-color: ${styles.colors.founders};
	color: ${styles.colors.black};
	padding: 4px 8px;
	& .hide-small {
		@media only screen and (max-width: 375px) {
			display: none;
		}
	}
	& .show-small {
		@media only screen and (min-width: 375px) {
			display: none;
		}
	}
	@media only screen and (max-width: 375px) {
		padding: 4px;
	}
`;

const StyledManageButton = styled.div`
	cursor: pointer;
	display: flex;
	align-items: center;
	@media only screen and (max-width: 480px) {
		& #pro-text {
			display: none;
		}
	}
`

const LinkText = styled.span`
	cursor: pointer;
	text-decoration: underline;
	font-family: ${styles.fonts.nunito};
	font-weight: ${({ variant }) => (variant === 'bold' ? 800 : 600)};
	font-size: 14px;
	line-height: 20px;
	color: ${({ color }) => (color ? color : `${styles.colors.white}`)};
	margin: 0;
`

const IconForType = ({ type }) => {
	switch (type) {
		case 'founders_series':
			return <FoundersIcon style={{ overflow: 'visible' }} />
		case 'founders_series_eligible':
			return <FoundersIconBlack style={{ overflow: 'visible' }} />
		case 'free':
			return <FreeIcon style={{ overflow: 'visible' }} />
		default:
			return <ProIconGold style={{ overflow: 'visible' }} />
	}
}

/**
 *
 * @param {{data: {
 *   user:{
 *     avatar:string,
 *     email:string,
 *     id:number,
 *     is_free_user:boolean,
 *     name:string
 *   },
 *   subscription_options:[{
 *     action:string,
 *     eligible_for_trial:boolean,
 *     is_current:boolean,
 *     link_target?:string,
 *     link_text?:string,
 *     status_text:string,status_type:string,
 *     subtitle?:string,
 *     title:string,type:string,
 *     offer:boolean,
 *     offer_badge_text?:string
 *   }],
 *   connect_adjust: {
 *     can_adjust_vehicle_connections:boolean,
 *     current_connections:number,
 *     max_connections:number,
 *     min_connections:number,
 *     stripe_is_vehicle_connections_only:boolean,
 *     stripe_has_vehicle_connections_item:boolean,
 *     pending_reduction_qty:number,
 *   },
 *   founders_membership:boolean,
 *   redemption_lookup_action:string,
 *   subscription_appstore:boolean,
 *   subscription_platform:string,
 *   subscription_renewal_message:string,
 *   vehicle_connections_message:string,
 *   confirmation?: {
 *     header: string,
 *     message: string,
 *     invoice_link: string,
 *   },
 *   redemption_code_prefill:string,
 *   subscription_auto_renew:boolean,
 *   subscription_payment_method_update_url:string,
 *   pricing:{
 *     annual:string,
 *     monthly:string,
 *   },
 *   one_click_trial:{
 *     eligible:boolean,
 *     monthly:string,
 *     annual:string,
 *   }
 * }}} props
 * @returns
 */
export default function ManageSubscription({
	data: {
		user,
		manage_url,
		subscription_options,
		redemption_lookup_action,
		redemption_code_prefill,
		subscription_platform,
		subscription_renewal_message,
		subscription_renewal_date,
		subscription_renewal_period,
		pricing,
		connect_adjust,
		confirmation,
		founders_membership,
		subscription_appstore,
		subscription_auto_renew,
		subscription_payment_method_update_url,
		vehicle_connections_message,
		upgrade_features,
		one_click_trial
	}
}) {
	// information for the vehicles table
	const [gettingVehicles, setGettingVehicles] = useState(false)
	const [connectionsUpdating, setConnectionsUpdating] = useState([])
	const [vehiclesData, setVehiclesData] = useState(null)
	const [vehiclesDataError, setVehiclesDataError] = useState('')
	// connection quantity adjustment information
	const [vehicleConnectionQtyAdjusting, setVehicleConnectionQtyAdjusting] = useState(false)
	const [vehicleConnectionQtyCompleting, setVehicleConnectionQtyCompleting] = useState(false)
	const [vehicleConnections, setVehicleConnections] = useState(null)
	const [vehicleConnectionsError, setVehicleConnectionsError] = useState('')
	// renewal panel state
	const [isTogglingAutoRenew, setIsTogglingAutoRenew] = useState(false)
	const [isAutoRenew, setIsAutoRenew] = useState(subscription_auto_renew)
	const [renewalMessage, setRenewalMessage] = useState(subscription_renewal_message)
	const [renewalError, setRenewalError] = useState('')
	// side panel states
	const [connectionPanelOpen, setConnectionPanelOpen] = useState(false)
	const [upgradePanelOpen, setUpgradePanelOpen] = useState(false)
	const [managePanelOpen, setManagePanelOpen] = useState(false)
	// toast message state
	const [toastMessageObject, setToastMessageObject] = useState(confirmation)
	// one click trial state
	const [loadingOneClickTrial, setLoadingOneClickTrial] = useState(false)

	const hideToast = (obj) => {
		if (obj?.reload_on_dismiss && manage_url) {
			window.location.href = manage_url;
		} else if (manage_url) {
			window.history.replaceState(
				{},
				'',
				manage_url
			);
		}
		setToastMessageObject(null)
	}

	const openAddVehicleConnections = () => {
		if (!connect_adjust.can_adjust_vehicle_connections && subscription_appstore) {
			onAppStoreFirstTimePress()
			return
		}
		if (user.is_free_user) {
			// open upgrade panel
			openUpgradePanel()
			return
		}
		setConnectionPanelOpen(true)
	}

	const closeAddVehicleConnections = () => {
		setVehicleConnectionsError('')
		setConnectionPanelOpen(false)
	}

	const openUpgradePanel = () => {
		setUpgradePanelOpen(true)
	}

	const closeUpgradePanel = () => {
		setUpgradePanelOpen(false)
	}

	const openManagePanel = () => {
		setManagePanelOpen(true)
	}

	const closeManagePanel = () => {
		setRenewalError('')
		setManagePanelOpen(false)
	}

	const updatingVehicle = vehicle => {
		return connectionsUpdating.includes(vehicle.vin)
	}

	// api calls
	const toggleVehicleConnection = async vehicle => {
		if (updatingVehicle(vehicle)) return
		if (!vehicle.connected && !vehicle.can_enable && vehiclesData?.enforce_limit_message){
			alert(vehiclesData?.enforce_limit_message)
			return
		}
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		setConnectionsUpdating([...connectionsUpdating, vehicle.vin])
		try {
			const { data } = await post(`/subscribe/${magic_link_auth_key}/manage/vehicle_connections`, { enabled: !vehicle.connected, vin: vehicle.vin })
			setVehiclesData(data)
		} catch (error) {
			console.error('Error updating vehicle connection', error)
			setVehiclesDataError(vehiclesData?.enforce_limit_message ?? 'There was an error updating your vehicle connection. Please try again.')
		} finally {
			setConnectionsUpdating(connectionsUpdating.filter(vin => vin !== vehicle.vin))
		}
	}

	const updateConnections = async qty => {
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		setVehicleConnectionQtyAdjusting(true)
		setVehicleConnectionsError('')
		setVehicleConnections(null)
		try {
			const { data } = await post(`/subscribe/${magic_link_auth_key}/manage/adjust_connections`, { new_quantity: qty })
			setVehicleConnections(data)
		} catch (error) {
			console.log('updateConnections Error', { error, qty })
			setVehiclesDataError(vehiclesData?.enforce_limit_message ?? 'There was an error updating your vehicle connection. Please try again.')
		} finally {
			setVehicleConnectionQtyAdjusting(false)
		}
	}

	const completeConnectionAdjustment = async () => {
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		setVehicleConnectionQtyCompleting(true)
		setVehicleConnectionsError('')
		try {
			const { data } = await post(`/subscribe/${magic_link_auth_key}/manage/adjust_connections`, { new_quantity: vehicleConnections.preview.new_quantity, confirmation_key: vehicleConnections.preview.confirmation_key })
			closeAddVehicleConnections()
			setVehicleConnections(data)
		} catch (error) {
			console.log('completeConnectionAdjustment Error', { error })
			setVehicleConnectionsError('There was an error updating your vehicle connections. Please try again.')
		} finally {
			setVehicleConnectionQtyCompleting(false)
		}
	}

	// redirects and handlers

	const onFoundersFirstTimePress = type => {
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		window.location.href = `/subscribe/${magic_link_auth_key}/manage/add_on_vehicle_connections/${type}`
	}

	const onAppStoreFirstTimePress = () => {
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		window.location.href = `/subscribe/${magic_link_auth_key}/manage/add_on_vehicle_connections`
	}

	const onPressProUpgrade = action => {
		if (action) window.location.href = action
	}

	const onManagePress = () => {
		if (!managePanelOpen && !(founders_membership && !connect_adjust.can_adjust_vehicle_connections)) {
			openManagePanel()
		} else {
			closeManagePanel()
			const magic_link_auth_key = window.location.pathname.split('/')[2]
			window.location.href = `/subscribe/${magic_link_auth_key}/manage/current`
		}
	}

	const toggleAutoRenew = async () => {
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		setIsTogglingAutoRenew(true)
		setRenewalError('')
		try {
			const { data } = await post(`/subscribe/${magic_link_auth_key}/manage/current/auto_renew`, { auto_renew: !isAutoRenew })
			setIsAutoRenew(data.auto_renewing)
			setRenewalMessage(data.subscription_renewal_message)
		} catch (error) {
			console.error('Error toggling auto renew', error)
			setRenewalError('There was an error updating auto renew. Please try again.')
		} finally {
			setIsTogglingAutoRenew(false)
		}
	}

	const doOneClickTrial = term => {
		setLoadingOneClickTrial(true)
		const magic_link_auth_key = window.location.pathname.split('/')[2]
		window.location.href = `/subscribe/${magic_link_auth_key}/trial/${term}`
	}

	useEffect(() => {
		// get the vehicles!
		const getVehicles = async () => {
			setGettingVehicles(true)
			setVehiclesDataError('')
			try {
				const magic_link_auth_string = window.location.pathname.split('/')[2]
				const { data } = await get(`/subscribe/${magic_link_auth_string}/manage/vehicle_connections`)
				setVehiclesData(data)
			} catch (error) {
				console.error('Error getting vehicles', error)
				setVehiclesDataError('There was an error getting your vehicles. Please try again.')
			} finally {
				setGettingVehicles(false)
			}
		}

		getVehicles()
	}, [])

	useEffect(() => {
		if (vehicleConnections?.confirmation) {
			setToastMessageObject(vehicleConnections.confirmation)
		}
	}, [vehicleConnections?.confirmation])

	return (
		<ScreenWrapper>
			<StyeldContainer>
				<Row>
					<Col>
						<UserRow>
							{user.avatar ? (
								<Avatar src={user.avatar} />
							) : (
								<AvatarBacker>{dissectName(user.name)}</AvatarBacker>
							)}
							<UserColumn>
								<Text.Heading
									type='h4'
									color={styles.colors.whiteGray}
									variant='bold'
								>
									{user.name}
								</Text.Heading>
								<Text.Caption
									color={styles.colors.lightGray}
									variant='bold'
								>
									{user.email}
								</Text.Caption>
							</UserColumn>
						</UserRow>
					</Col>
				</Row>
				<Row className='d-flex align-items-center' style={{ borderBottom: `1px solid ${styles.colors.darkGray}`, paddingBottom: '16px', marginBottom: '48px' }}>
					<Col xs={9}>
						<StyledCol style={{ height: '100%', justifyContent: 'center' }}>
							<Text.Caption color={styles.colors.founders} variant='bold'>TezLab {user.is_free_user ? 'Free' : founders_membership ? 'Pro (Founders Series)' : 'Pro'}{subscription_renewal_period ? ` / ${subscription_renewal_period}` : ''}</Text.Caption>
							{!user.is_free_user && (
								<>
								<StyledRow>
									{!!subscription_platform && <Text.Caption color={styles.colors.lightGray}>
										{renewalMessage ? `${renewalMessage}` : ' '}
										{(subscription_platform === 'TezLab' || !!founders_membership) && (
											<LinkText variant='bold' color={styles.colors.lightGray} onClick={onManagePress} style={{ marginLeft: '8px' }}>Manage Membership</LinkText>
										)}
										{!!subscription_payment_method_update_url?.url &&
											<p>⚠️<LinkText variant='bold' color={styles.colors.founders} onClick={()=>{window.location.href=subscription_payment_method_update_url.url}} style={{ marginLeft: '3px' }}>Add Payment Method</LinkText></p>
										}
									</Text.Caption>}
								</StyledRow>
								</>
							)}
							{user.is_free_user && subscription_options?.some(x=>x.offer) && (
								<>
								<StyledRow style={{ marginTop: '8px'}}><b>Special Offer{subscription_options?.filter(x=>x.offer).length > 1 ? 's' : ''} Available:</b><br/></StyledRow>
									
									{subscription_options?.filter(x=>x.offer).map(x=>{
										return (
										<StyledRow style={{ marginTop: '4px', marginRight: "24px"}}>
												<Text.Caption key={x.id} color={styles.colors.lightGray}>{x.offer_badge_text}</Text.Caption>
										</StyledRow>
										)
									})}
								</>
							)}
						</StyledCol>
					</Col>
					<Col xs={3}>
						<StyledRow style={{ justifyContent: 'flex-end' }}>
							{user.is_free_user ? (
								<ProUpgradeButton onClick={openUpgradePanel}>
									<ProIconBlack style={{ marginRight: '8px' }} />
									<span>Upgrade</span>
								</ProUpgradeButton>
							) : (
								<StyledManageButton onClick={onManagePress}>
									<IconForType type={founders_membership ? 'founders_series' : user.is_free_user ? 'free' : 'pro'} />
									{founders_membership && (
										<Text.Caption id='pro-text' style={{ marginLeft: '8px' }} variant='bold' color={styles.colors.founders}>Founders Series</Text.Caption>
									)}
									{!founders_membership && !user.is_free_user && (
										<Text.Caption id='pro-text' style={{ marginLeft: '8px' }} variant='bold' color={styles.colors.founders}>TezLab Pro</Text.Caption>
									)}
								</StyledManageButton>
							)}
						</StyledRow>
						
					</Col>
				</Row>

				{one_click_trial?.eligible && one_click_trial?.monthly && one_click_trial?.annual && pricing?.monthly && pricing?.annual && (
					<Row style={{ marginBottom: '48px', backgroundColor: styles.colors.founders, borderRadius: '8px', padding: '16px 12px' }}>
						<Col xs={12} lg={8}>
							<StyledRow style={{ marginTop: '8px' }}>
								<ProIconBlack /> 
								<Text.Caption variant='bold' color={styles.colors.black} style={{ marginLeft: '8px' }}>You're eligible for a FREE 14-day trial of Pro - No Payment Method Required!</Text.Caption>	
							</StyledRow>
							<StyledRow style={{ marginTop: '8px' }}>
								<Text.Caption color={styles.colors.black} style={{ marginLeft: '8px' }}>Try TezLab Pro risk free for 14 days! To get started with one click, choose your preferred plan interval. No payment method is required today - we'll remind you toward the end of your trial.</Text.Caption>	
							</StyledRow>
						</Col>
						<Col xs={12} lg={4}>
							<StyledRow style={{ marginTop: '8px', justifyContent: 'flex-end' }}>
								{loadingOneClickTrial ? (
									<SpinnerWrapper>
										<Spinner animation='border' variant='dark' />
									</SpinnerWrapper>
								) : (
									<>
										<Button onClick={()=>{doOneClickTrial("monthly")}} color={styles.colors.founders} style={{ backgroundColor: styles.colors.black, margin: '0px 4px' }}>{pricing.monthly}/month</Button>
										<Button onClick={()=>{doOneClickTrial("annual")}} color={styles.colors.founders} style={{ backgroundColor: styles.colors.black, margin: '0px 4px' }}>{pricing.annual}/year</Button>
									</>
								)}
							</StyledRow>
						</Col>
					</Row>
					)
				}
				
				{subscription_options?.filter(o=>{return (o.type === 'founders_series' && o.status_type === 'link' && user.is_free_user != true && o.action)}).map(o=>{
					return (
					<Row style={{ marginBottom: '48px', backgroundColor: styles.colors.founders, borderRadius: '8px', padding: '16px 12px' }}>
						<Col>
							<StyledRow style={{ marginTop: '8px' }}>
								<IconForType type='founders_series_eligible'/> 
								<Text.Caption variant='bold' color={styles.colors.black} style={{ marginLeft: '8px' }}>You're eligible to join Founders Series!</Text.Caption>	
							</StyledRow>
						</Col>
						<Col>
							<StyledRow style={{ marginTop: '8px', justifyContent: 'flex-end' }}>
								<LinkText variant='bold' color={styles.colors.black} style={{ marginRight: '16px' }} onClick={()=>{window.open("https://tezlabapp.com/founders", '_blank')}}>Learn More</LinkText>
								<Button onClick={()=>{window.location.href=o.action}} color={styles.colors.founders} style={{ backgroundColor: styles.colors.black }}>Join Now</Button>
							</StyledRow>
						</Col>
					</Row>
					)
				})}
				{vehiclesData?.vehicles?.length && (<Row>
					<Col>
						<Text.Heading variant='bold' type='h4' color={styles.colors.dimHighlight} style={{ marginBottom: '24px' }}>{vehiclesData?.connections_active}/{vehiclesData?.connections_allowed} Vehicle{vehiclesData?.connections_allowed > 1 ? 's' : ''} Connected</Text.Heading>
					</Col>
				</Row>)}
				<Row>
					<Col>
						{!!vehicle_connections_message && (
							<ConnectionMessageWrapper>
								<StyledRow column='480px'>
									<div className='icon'>
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ marginRight: '32px', scale: 1.5 }}>
											<path fillRule="evenodd" clipRule="evenodd" d="M19 11C21.7614 11 24 8.76142 24 6C24 3.23858 21.7614 1 19 1C16.2386 1 14 3.23858 14 6C14 8.76142 16.2386 11 19 11ZM19 6.75C18.5858 6.75 18.25 6.41421 18.25 6V3.75C18.25 3.33579 18.5858 3 19 3C19.4142 3 19.75 3.33579 19.75 3.75V6C19.75 6.41421 19.4142 6.75 19 6.75ZM18.25 8.5C18.25 8.91421 18.5858 9.25 19 9.25C19.4142 9.25 19.75 8.91421 19.75 8.5C19.75 8.08579 19.4142 7.75 19 7.75C18.5858 7.75 18.25 8.08579 18.25 8.5ZM12 6C12 5.66048 12.0242 5.3266 12.0709 5H4C3.44772 5 3 5.44772 3 6V21C3 21.3679 3.20199 21.7061 3.5259 21.8805C3.84981 22.0549 4.24333 22.0374 4.55046 21.8349L10.8 17.7143H19C19.5523 17.7143 20 17.2666 20 16.7143V12.9291C19.6734 12.9758 19.3395 13 19 13C18.6605 13 18.3266 12.9758 18 12.9291V15.7143H10.5C10.3043 15.7143 10.1129 15.7717 9.94954 15.8794L5 19.1429V7H12.0709C12.0242 6.6734 12 6.33952 12 6Z" fill="#FF9839" />
										</svg>
									</div>
									<div>
										{!!vehicle_connections_message?.header && (<Text.Caption variant='bold'>{vehicle_connections_message?.header}</Text.Caption>)}
										{!!vehicle_connections_message?.message && (<Text.Caption>{vehicle_connections_message?.message}</Text.Caption>)}
									</div>
								</StyledRow>
							</ConnectionMessageWrapper>
						)}
						<Skeleton isLoading={gettingVehicles} width='100%' height='100px' style={{ borderRadius: '0', margin: '1px 0' }}>
							{!vehiclesData?.vehicles?.length && (
								<VehicleWrapper>
									<Text.Body variant='bold' color={styles.colors.dimHighlight}>{vehiclesDataError || 'No vehicles found.'}</Text.Body>
								</VehicleWrapper>
							)}
							{vehiclesData?.vehicles?.map((vehicle, index) => (
								<VehicleWrapper key={vehicle.vin} isLast={index === vehiclesData?.vehicles?.length - 1 && !redemption_lookup_action}>
									<VehicleImage src={vehicle.image_url} alt={vehicle.car_type} />
									<StyledCol>
										<Text.Heading type='h4' mobileL='h6' mobileS='body' variant='bold' color={styles.colors.dimHighlight} allowWidows>{vehicle.display_name}</Text.Heading>
										<StyledRow>
											{vehicle.make === 'tesla' && (
												<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
													<path fillRule="evenodd" clipRule="evenodd" d="M13.6791 3.86256C11.6791 2.99052 9.72179 2.7109 8.01562 2.72512C6.30946 2.71564 4.35212 2.99052 2.35212 3.8673C2.11515 3.43128 2.01562 3.17062 2.01562 3.17062C4.2052 2.30332 6.25259 2.00948 8.01562 2C9.7834 2.00948 11.8308 2.30332 14.0156 3.16588C14.0156 3.16588 13.9445 3.37915 13.6791 3.86256ZM9.69807 4.50709L8.02034 13.9526L6.33314 4.50709C4.74546 4.50709 4.23835 4.68245 4.16726 5.39809C4.16726 5.39809 3.09143 4.99998 2.55115 4.18482C4.66489 3.20378 6.78812 3.16112 6.78812 3.16112L8.02271 4.66534L9.25731 3.16112C9.25731 3.16112 11.3805 3.20378 13.4943 4.18482C12.954 4.99998 11.8782 5.39809 11.8782 5.39809C11.8023 4.68245 11.3 4.50709 9.69807 4.50709Z" fill="#9EA6B7" />
												</svg>
											)}
											{vehicle.make === 'rivian' && (
												<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
													<path d="M14.3403 7.52C13.6419 6.8 9.86375 2.906 9.15545 2.3435C8.90795 2.1452 8.58695 2 8.19095 2C7.79495 2 7.47305 2.1452 7.22645 2.3435C6.51845 2.906 2.73695 6.8 2.04095 7.52C1.98095 7.586 2.03555 7.6886 2.12135 7.6886L3.76655 7.6898C3.93815 7.6898 3.98915 7.6598 4.09715 7.544L4.74215 6.8516C5.42525 6.1151 7.09115 4.4891 7.70015 3.9767C7.92875 3.7841 8.18765 3.7907 8.19125 3.7907C8.19485 3.7907 8.45375 3.7847 8.68235 3.9767C9.29135 4.4867 10.9572 6.1157 11.6403 6.8516L12.2853 7.544C12.3933 7.6598 12.4443 7.6898 12.6159 7.6898L14.2611 7.6886C14.3469 7.6892 14.3973 7.5857 14.3403 7.52ZM2.04095 8.4509C2.73935 9.1709 6.51755 13.0685 7.22555 13.6307C7.47275 13.8287 7.79075 13.9742 8.19005 13.9742C8.58935 13.9742 8.90795 13.829 9.15455 13.6307C9.86255 13.0685 13.641 9.1712 14.3394 8.4509C14.3994 8.3849 14.3448 8.2823 14.259 8.2823C13.9101 8.2823 13.101 8.2811 12.6141 8.2811C12.4425 8.2811 12.3915 8.3111 12.2835 8.4269L11.6385 9.119C10.9554 9.8555 9.28955 11.4815 8.68055 11.9939C8.45195 12.1865 8.19305 12.1799 8.18945 12.1799C8.18585 12.1799 7.92695 12.1859 7.69835 11.9939C7.08935 11.4839 5.42345 9.8549 4.74035 9.119L4.09535 8.4269C3.98735 8.3111 3.93635 8.2811 3.76475 8.2811L2.11955 8.2823C2.03495 8.2823 1.98395 8.3852 2.04095 8.4509ZM7.73405 9.2759L6.66965 8.2208C6.57965 8.1152 6.57965 7.9808 6.57965 7.9808C6.57965 7.9808 6.57365 7.8488 6.66965 7.7408C6.87365 7.5023 7.41965 6.9698 7.73405 6.6857C7.86155 6.5669 7.89215 6.4919 7.89215 6.3461V4.73C7.89215 4.6649 7.81625 4.6244 7.75715 4.679C7.06235 5.3222 5.51495 6.8558 4.99625 7.4498C4.74785 7.7129 4.77125 7.9808 4.77125 7.9808C4.77125 7.9808 4.74845 8.2508 4.99625 8.5118C5.51525 9.1058 7.06625 10.6394 7.75715 11.2826C7.81895 11.3366 7.89215 11.3027 7.89215 11.2262V9.6131C7.89215 9.4631 7.86155 9.3911 7.73405 9.2729V9.2759ZM8.64755 9.2771L9.71195 8.222C9.80195 8.1164 9.80195 7.982 9.80195 7.982C9.80195 7.982 9.80795 7.85 9.71195 7.742C9.50795 7.5035 8.96195 6.971 8.64755 6.6869C8.52005 6.5681 8.48945 6.4931 8.48945 6.3473V4.739C8.48945 4.6625 8.56235 4.6286 8.62445 4.6826C9.31925 5.3258 10.8666 6.8594 11.3853 7.4534C11.6331 7.7165 11.6103 7.9844 11.6103 7.9844C11.6103 7.9844 11.6331 8.2544 11.3853 8.5154C10.8663 9.1094 9.31535 10.643 8.62445 11.2862C8.56265 11.3402 8.48945 11.3063 8.48945 11.2298V9.617C8.49005 9.467 8.52005 9.3959 8.64755 9.2771Z" fill="#9EA6B7" />
												</svg>
											)}
											<Text.Caption color={styles.colors.lightGray} mobileL='tiny'>{vehicle.car_type}</Text.Caption>
										</StyledRow>
									</StyledCol>
									<StyledRow columnReverse='375px' style={{ flex: 0 }}>
										<ConnectedText mobileL='tiny' style={{ marginRight: '12px' }} variant='bold' color={vehicle.connected ? styles.colors.success : styles.colors.lightGray}>{vehicle.connected ? 'Connected' : 'Disconnected'}</ConnectedText>
										{updatingVehicle(vehicle) ? (
											<SpinnerWrapper>
												<Spinner animation='border' variant='light' />
											</SpinnerWrapper>
										) : (
											<StyledSwitch
												checked={vehicle.connected}
												onChange={() => toggleVehicleConnection(vehicle)}
												disabled={user.is_free_user && !vehicle.connected && !vehicle.can_enable}
											/>
										)}
									</StyledRow>
								</VehicleWrapper>
							))}
						</Skeleton>
						{!!redemption_lookup_action && user.is_free_user && (
							<GiftRedemptionPanel
								gift_redemption_lookup={redemption_lookup_action}
								{...{
									redemption_code_prefill,
								}}
							/>
						)}
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledCol style={{ alignItems: 'center', marginTop: '16px' }}>
							<Button onClick={openAddVehicleConnections}>{connect_adjust?.can_adjust_vehicle_connections ? 'Adjust' : 'Add'} Vehicle Connections</Button>
						</StyledCol>
					</Col>
				</Row>
			</StyeldContainer>
			<AddConnectionsMenu
				currentConnections={vehicleConnections?.preview?.new_quantity ?? connect_adjust?.pending_reduction_qty ?? connect_adjust?.current_connections}
				minConnections={connect_adjust?.min_connections}
				maxConnections={connect_adjust?.max_connections}
				showFoundersUI={founders_membership && !connect_adjust?.can_adjust_vehicle_connections}
				updateConnections={updateConnections}
				show={connectionPanelOpen}
				onHide={closeAddVehicleConnections}
				pricing={pricing}
				previewData={vehicleConnections?.preview}
				loading={vehicleConnectionQtyAdjusting}
				completing={vehicleConnectionQtyCompleting}
				onComplete={completeConnectionAdjustment}
				onFoundersCheckout={onFoundersFirstTimePress}
				{...{ vehicleConnectionsError }}
			/>
			<ProUpgradeMenu onPress={onPressProUpgrade} show={upgradePanelOpen} onHide={closeUpgradePanel} {...{ subscription_options, pricing }} features={upgrade_features.features} keyFeatures={upgrade_features.key_features.filter(feature => feature.is_free === false)} disclaimer={upgrade_features.disclaimer} foundersDisclaimer={upgrade_features.founders_disclaimer} />
			<ManageSubscriptionPanel
				show={managePanelOpen}
				onHide={closeManagePanel}
				subscription={{
					type: founders_membership ? 'Founders' : subscription_platform ? 'Pro' : 'Free',
					renewalType: subscription_renewal_period,
					renewalMessage,
					isAutoRenew,
					showManageButton: (founders_membership && connect_adjust.stripe_has_vehicle_connections_item) || (!founders_membership && subscription_platform === 'TezLab') || (vehicleConnections?.preview?.new_quantity ?? connect_adjust?.current_connections > 1),
					connectAdjust: connect_adjust,
					subscriptionPlatform: subscription_platform,
				}}
				isTogglingAutoRenew={isTogglingAutoRenew}
				vehicleConnection={{ addOnQty: connect_adjust?.current_connections }}
				onManagePress={onManagePress}
				toggleAutoRenew={toggleAutoRenew}
				{...{ renewalError }}
			/>
			<MessageToast show={!!toastMessageObject} heading={toastMessageObject?.header} body={toastMessageObject?.message} onHide={()=>hideToast(toastMessageObject)} options={{ error: toastMessageObject?.error }} />
		</ScreenWrapper>
	)
}
